import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';

import styles from './installation-costs-message.scss';

function InstallationCostsMessage() {
  return (
    <Typography
      className={cn(styles['installation-costs'], 'installation-costs-message')}
      size="small"
    >
      + Installation costs added in cart
    </Typography>
  );
}

export default InstallationCostsMessage;
